import { makeActonCreator } from '../util';

export const UPDATE_LOGIN_STATUS = 'UPDATE_LOGIN_STATUS';
export const UPDATE_MODAL_VISIBLE = 'UPDATE_MODAL_VISIBLE';
export const UPDATE_DISPLAY_NAME = 'UPDATE_DISPLAY_NAME';
export const TOGGLE_MOBILE_NAV_BAR = 'TOGGLE_MOBILE_NAV_BAR';
export const UPDATE_CURRENT_PAGE = 'UPDATE_CURRENT_PAGE';
export const UPDATE_USER_AGENT_DETAILS = 'UPDATE_USER_AGENT_DETAILS';

export const updateLoginStatus = makeActonCreator(UPDATE_LOGIN_STATUS);
export const updateModalVisible = makeActonCreator(UPDATE_MODAL_VISIBLE);
export const updateDisplayName = makeActonCreator(UPDATE_DISPLAY_NAME);
export const toggleMobileNavBar = makeActonCreator(TOGGLE_MOBILE_NAV_BAR);
export const updateCurrentPage = makeActonCreator(UPDATE_CURRENT_PAGE);
export const updateUserAgentDetails = makeActonCreator(
  UPDATE_USER_AGENT_DETAILS,
);
